import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessagingAccessToken } from 'src/app/swagger-api';
import { BaseCacheService } from './base-cache-helper.service';

@Injectable({ providedIn: 'root' })
export class ChatTokenService extends BaseCacheService<MessagingAccessToken> {
  protected override fetchFromApi(): Observable<MessagingAccessToken> {
    return this.apiService.restSocialProfileMessagingAccessPost();
  }

  public override getLocalStorageKey(): string {
    return 'chat-token-data';
  }
}
